import { z } from 'zod'

export const GetDeviceDashboardUrlVariablesSchema = z.object({
    dashboard_id: z.number().int(),
    params: z.any()
})

export type GetDeviceDashboardUrlVariables = z.infer<typeof GetDeviceDashboardUrlVariablesSchema>

export const GetDeviceDashboardUrlQuerySchema = z.object({
    metabase_url: z.string().nullish()
})

export type GetDeviceDashboardUrlQuery = z.infer<typeof GetDeviceDashboardUrlQuerySchema>
